var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"wechat-popover"},[_c('div',{staticClass:"popover-card"},[_c('LoginWeChat',{attrs:{"platform":"wechat","text1":"关注服务号","text2":"接收重要通知推送","type":"popover","api":"getThirdPartyBindCode"},on:{"ok":_vm.onBindSuccess}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }